import React, { Component, Suspense } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import u from 'updeep';
import Link from '../Link';
import List from '../List';
import Button from '../Button';
import SvgIcon from '../SvgIcon';
import TextField from '../TextField';
import Columnizer from '../Columnizer';
import LoaderBlock from '../LoaderBlock';
import Suggestion from './Suggestion';
import Frame from 'react-frame-component';
import { keyCodes, fontUrls, roles as availableRoles, gaEventCategories, gaEventActions, gaEventLabel, links , selectionStates , bookStatus , operatingSystems, SUGGEST_EDIT_LANGUAGES , horizontalScreenImages , verticalScreenImages , authorHorizontalScreenImages, authorVerticalScreenImages, userFeedbackPopups , pageType , gaReadSource, sectionClicked, mapUserGatewayProfileType, userProfileType, sanitizeHref } from '../../lib/constants';
import {getImageSize} from '../../lib/images';
import AudioPlayer from './AudioPlayer';
import EditBookDetailModal from '../Book/EditBookDetailModal';
import ConfirmModal from '../ConfirmModal';
import ModalControlButton from '../ModalControlButton';
import {getOS} from '../../lib/operatingSystem';
import './BookReader.scss';
import PortraitViewMessage from '../PortraitViewMessage';

const getCueInfo = () => {
  let iframe = document.getElementsByClassName('pb-book-reader__frame')[0];
  let iframes = Array.from(document.getElementsByClassName("pb-book-reader__frame"))
  let finalInnerDoc;
  let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
  finalInnerDoc = innerDoc
  if(iframes.length > 0 && window.location.pathname.includes("/stem-literacy-programme")) {
    iframes.forEach(el => {
      let innerDoc = el.contentDocument || el.contentWindow.document;
      let cue = innerDoc.querySelectorAll('[data-cue]')
      if (cue.length > 0) {
        finalInnerDoc = innerDoc        
      }
    })
  }
  let arrCue = [...finalInnerDoc.querySelectorAll('[data-cue]')].map(node => node.dataset.cue)
  let minCue = Math.min(...arrCue), 
      maxCue = Math.max(...arrCue);
  return [minCue, maxCue, finalInnerDoc];
  
}

const getInnerHTML = () => {
  let iframe = document.getElementsByClassName('pb-book-reader__frame')[0];
  let innerDoc = iframe.contentDocument || iframe.contentWindow.document;
  let contentEl = innerDoc.getElementById('storyReader');
  return [innerDoc , contentEl];
}


class BookReader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalVisible: {
        editBookDetail: false,
        confirmEdit: false,
      },
      imageBlobs: {},
      seekCueIdx: 1,
      playing: false,
      disableAudioControls: false, // disable audio controls if no cues are found in current page
      currentPage: this.props.startPage || 1,
      isLoadingCss: true,
      startTime: 0,
      totalReadTime: 0,
      audioBlob: null,
      coverAudioBlob: null,
      isEditing: false,
      isTyping:false,
      editorLoading: false,
      suggestionDescription : '',
      isButtonClicked: false,
      isFullScreenClicked: false,
      screenImage : this.props.orientation === "landscape" ? horizontalScreenImages.first : verticalScreenImages.first ,
      authorScreenImage: this.props.orientation === "landscape" ? authorHorizontalScreenImages.first : authorVerticalScreenImages.first ,
      data: {
        selected : '',
        suggestion : '',
        id : ''
      },
      hasNextPage: true,
      landscapeMode: false
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }
  onOpenModal(modalName) {
    this.setState(u({
      isModalVisible: {
        [modalName]: true
      }
    }, this.state));

  }

  onCloseModal(modalName) {
    this.setState(u({
      isModalVisible: {
        [modalName]: false
      }
    }, this.state));
  }

  componentDidMount() {
    this.props.disablePortraitViewMessage();

    if (window.fbq) {
			window.fbq('track', 'Lead');
    }

    this.gtag_report_conversion();

    if(!this.props.lp) document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('webkitfullscreenchange', this.exitHandler);
    document.addEventListener('mozfullscreenchange', this.exitHandler);
    document.addEventListener('fullscreenchange', this.exitHandler);
    document.addEventListener('MSFullscreenChange', this.exitHandler);

    if (this.state.isLoadingCss) {
      return;
    }

    const iframeEl = ReactDOM.findDOMNode(this.iframeWrapperEl).querySelector('iframe');
    // Shitty cross-browser way of adding a keydown listener to an iframe's
    // document. On Firefox, you can't add the event until the iframe's "load"
    // event has fired, so you need to add the event inside the handler for the "load"
    // event. But, on IE and Safari you can't hook into the "load" event at all, so
    // now you have to do long polling on the iframe's document's readyState.
    const pollingTimeMs = 300;
    let timeElapsedMs = 0;
    const timer = setInterval(() => {
      // Clear the interval if, for some reason, the readyState never gets to
      // "complete".
      timeElapsedMs = timeElapsedMs + pollingTimeMs;
      if (timeElapsedMs >= pollingTimeMs * 20) {
        clearInterval(timer);
      }

      if (iframeEl.contentDocument.readyState === 'complete') {
        clearInterval(timer);
        iframeEl.contentDocument.addEventListener('keydown', this.onKeyDown);
      }
    }, pollingTimeMs);
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.isLoadingCss !== prevState.isLoadingCss) {
      // autoplay preface audio on mount only on desktop devices
      if ( window.location.search.slice(1).split('=')[0] !== "mode") {      
        (this.props.viewport.medium && this.props.assets.isAudio && this.props.showAudioBookReader && this.initializeSeekCue() );
      }
      let iframes = Array.from(document.getElementsByClassName("pb-book-reader__modal-wrapper"))
      if(iframes.length > 0) {
        iframes.forEach(el => {
          el.addEventListener('click', ()=> this.setState({activeEl: el}));
          // if(this.props.orientation === "landscape" ) {
          //   console.log("go fullscreen ", this.props.orientation)
          //   var myScreenOrientation = window.screen.orientation;
          //   myScreenOrientation.lock("landscape");
          //   this.onFullScreen()
          // }
          el.addEventListener('touchstart', this.handleTouchStart) 
          el.addEventListener('touchmove', this.handleTouchMove) 
        })
      }
    }

    if(this.props.ptr && this.state.activeEl) {
      let id = this.state.activeEl.id
      if(parseInt(id, 10) === parseInt(this.props.id, 10)) {
        document.getElementById(id).addEventListener('keydown', this.onKeyDown)
      } 
    }


    if(this.state.activeEl !== prevState.activeEl && this.state.activeEl && this.props.lp) {
      let id = this.state.activeEl.id
      if(id === this.props.id) document.getElementById(id).addEventListener('keydown', this.onKeyDown)
    }

    if(this.props.id !== prevProps.id && this.props.lp) {
      this.setState({currentPage: this.props.startPage})
    }
    
    if (this.state.playing !== prevState.playing) {
      if(this.state.playing) {
        this.setState({
          startTime: Date.now()
        })
      }
      else {
        let totalReadTime = this.state.totalReadTime + (Date.now() - this.state.startTime)
        this.setState({
          totalReadTime
        })
      }
    }

    let el = document.getElementsByTagName("body")[0]
    if(el && (this.state.editorLoading)) {
      el.style.opacity = 0.5;
      el.style.pointerEvents = "none";
    }
    else {
      el.style.opacity = 1;
      el.style.pointerEvents = "initial";
    }
  }

  componentWillMount() {
    fetch(this.props.cssHref)
      .then(response => response.blob())
      .then(imageBlob => {
        const objectURL = URL.createObjectURL(imageBlob);
        this.setState({
          cssBlob: objectURL,
          isLoadingCss: false
        })
      })
      .catch(err => {
        console.error(err);
        this.setState({ isLoadingCss: false });
      });

    let imageBlobs = this.state.imageBlobs;
    this.props.pages.forEach((page) => {
      if (page.coverImage && !this.state.imageBlobs[page.pageId]) {
        //https://medium.com/@gabriele.cimato/on-how-to-store-an-image-in-redux-d623bcc06ca7
        // for screen-landscape-lock function, vertical mode was opening but after locking it was taking the same image into landscape mode. Resulting in image pixelation. By taking max of width and height it was resolved. 
        const imageSize = getImageSize(Math.max(this.props.windowDimensions.width, this.props.windowDimensions.height))
        fetch(page.coverImage.sizes[imageSize - 1].url)
        .then(response => response.blob())
        .then(imageBlob => {
          let objectURL = URL.createObjectURL(imageBlob);
          imageBlobs[page.pageId] = objectURL;
          this.setState({
            imageBlobs: imageBlobs
          })
        });
      }
    });

    if (this.props.assets.isAudio) {
      fetch(this.props.assets.audioPath)
        .then(response => response.blob())
        .then(audioBlob => {
          const objectURL = URL.createObjectURL(audioBlob);
          this.setState({
            audioBlob: objectURL
          });
        })
        .catch(err => {
          const { offline, showAudioBookReader, addSlimNotification } = this.props
          showAudioBookReader && offline && addSlimNotification({
            type: 'danger',
            content: 'Audio file is missing! Please Re-Save the Story.',
          });
        });

      fetch(this.props.assets.coverAudioPath)
        .then(response => response.blob())
        .then(coverAudioBlob => {
          const objectURL = URL.createObjectURL(coverAudioBlob);
          this.setState({
            coverAudioBlob: objectURL
          });
        })
        .catch(err => {
          const { offline, showAudioBookReader, addSlimNotification } = this.props;
          showAudioBookReader && offline && addSlimNotification({
            type: 'danger',
            content: 'Cover audio file is missing! Please Re-Save the Story.',
          });
        });;
    }
    if (this.props.hideRotatePopup) {
      this.props.disablePortraitViewMessage();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.cssHref !== nextProps.cssHref) {
      this.setState({ isLoadingCss: true })
      fetch(nextProps.cssHref)
        .then(response => response.blob())
        .then(imageBlob => {
          const objectURL = URL.createObjectURL(imageBlob);
          this.setState({
            cssBlob: objectURL,
            isLoadingCss: false
          })
        });
    }
  }

  isUserNotAuthor = () => {
    const { assets , userId} = this.props
    if( assets.authors ) {
    let isUserAuthor = assets.authors.filter(author => author.id === userId);
    return isUserAuthor.length <= 0
    }
  }

  onBeforeEditor = (slug, urlCreator) => {
    const { viewport, addSlimNotification, t } = this.props;

    if (viewport.medium) {
      window.location.href = urlCreator(slug)
    } else {
      addSlimNotification({
        id: 'Book.mobile-editor-notification',
        content: t('Book.mobile-editor-notification-text'),
      });
    }
  }

  onEdit = () => {
    this.setState({editorLoading: true}, ()=> {
      this.onBeforeEditor(this.props.book.slug, links.editPublishedStory);
    })
  }

  renderSuggestionEls(baseClassName) {
    const { suggestions , t ,  book  , userId , resolveSuggestionsWorkflow, blockUserWorkflow , blockStoryWorkflow , addSlimNotification , assets , viewport , isUserBlocked ,userBlockedById , pages, updatePageContent  } = this.props;
    return suggestions.map( suggestion => {
      return (
        <List key={suggestion.suggestionId}>
            <Suggestion
              t = {t}
              assets={assets}
              pages={pages}
              currentPage={this.state.currentPage}
              suggestions={suggestions}
              suggestion={suggestion}
              baseClassName={baseClassName}
              book={book}
              viewport={viewport}
              userId={userId}
              init={this.init}
              userBlockedById={userBlockedById}
              isUserBlocked={isUserBlocked}
              updatePageContent={updatePageContent}
              blockUserWorkflow={blockUserWorkflow}
              blockStoryWorkflow={blockStoryWorkflow}
              resolveSuggestionsWorkflow={resolveSuggestionsWorkflow}
              addSlimNotification={addSlimNotification}
              onEdit={ book.status === bookStatus.published && viewport.medium && book.canEditOrgStory ? this.onOpenModal.bind(this, 'editBookDetail') : this.onOpenModal.bind(this, 'confirmEdit')}
            />
        </List>
      )
    });
  }
  
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    this.props.resetSuggestions();
  }

   gtag_report_conversion = (url) => {
    var callback = function () {
      if (typeof(url) !== 'undefined') {
        window.location = url
      }
    };
    window.gtag('event', 'conversion', {
        'send_to': process.env.REACT_APP_AW_CONVERSION_ID_WITH_LABEL,
        'event_callback': callback
    });
    return false;
  }

  onKeyDown = (e) => {
    if (e.keyCode === keyCodes.rightArrow && !this.state.isTyping) {
      this.nextPage();
    } else if (e.keyCode === keyCodes.leftArrow && !this.state.isTyping) {
      this.prevPage();
    } else if (e.keyCode === keyCodes.f && this.state.isEditing === false) {
      this.onFullScreen();
    } else if (e.keyCode === keyCodes.esc) {
      e.stopPropagation();
      this.onClose();
    }
  };

  onKeyPress = (e) => {
    if (e.charCode === keyCodes.return ) {
        this.submitSuggestion();
    }
  };

  onChangeDescriptionClicked = (e) => {
    this.setState({ suggestionDescription : e.target.value })
  }

  init = () => {
    const { assets } = this.props 
    let innerDoc = getInnerHTML()[0];
    let contentEl = getInnerHTML()[1];
    let pageNumberEl=contentEl.getElementsByClassName("page_number")[0];
    if(pageNumberEl)
      pageNumberEl.style.visibility="hidden";

    if (!contentEl.classList.contains("has_spans")) {
      let svgEl = contentEl.querySelector('svg')
      if (this.state.isEditing === true && svgEl) {
        contentEl.removeChild(svgEl);
      }
    }

    if (!this.props.viewport.medium) {
      contentEl.querySelectorAll(".has_comments").forEach(el => {
        el.classList.remove("has_comments");
      })
    }  

    if (this.props.offline) {
      contentEl.querySelectorAll(".has_comments").forEach(el => {
        el.classList.remove("has_comments");
      })
    }  

    if (this.state.isEditing === false) {
      contentEl.querySelectorAll(".has_comments").forEach(el => {
        el.classList.remove("has_comments");
        el.classList.add("has_some_comments");
      })
    }

    if (!contentEl.classList.contains("has_spans")) {
      contentEl.classList.add("has_spans");
      setTimeout(() => this.getLeafNodes(contentEl), 1000);
    }
    if (!this.props.isLoggedIn) {
      contentEl.querySelectorAll(".has_comments").forEach(el => {
        el.classList.remove("has_comments");
      })
    }   
    
    if (this.isUserNotAuthor()) {
      contentEl.querySelectorAll(".has_comments").forEach(el => {
          if(assets.reviewerSuggestions === null) {
            el.classList.remove("has_comments");
            el.classList.add("has_other_comments");
          } else{
            let commonEls = assets.reviewerSuggestions.filter(x => el.classList.contains(x));
            if(commonEls.length === 0 ) {
             el.classList.remove("has_comments");
             el.classList.add("has_other_comments");
          } 
        }
      })
    }
    if(contentEl && contentEl.getElementsByClassName("content")[0]){
      contentEl.getElementsByClassName("content")[0].style.visibility = "visible"
    }
    
    contentEl.addEventListener('mouseup', this.handleMouseUp.bind(null, innerDoc))
    contentEl.addEventListener('mouseover', this.handleMouseOver.bind(null)) 
  }

  handleMouseOver = (event) => {
    const { fetchSuggestionsWorkflow, assets } = this.props
    let suggestionIDList = [];
    if (!event.target.classList.contains("has_comments")) return ;
    suggestionIDList = Array.from(event.target.classList);
    const valueToRemove = 'has_comments'
    const onlyHexId = suggestionIDList.filter(id => id !== valueToRemove) 
    //interpolating a [] at the end of the query , so that in the ids's url the params goes as a array
    let suggestionIds = {};
    suggestionIds[`${"ids"}[]`] = onlyHexId
    if (this.isUserNotAuthor()) {
      if (assets.reviewerSuggestions === null) return;
      suggestionIds[`${"ids"}[]`] = suggestionIDList.filter((id) => assets.reviewerSuggestions.includes(id))
      fetchSuggestionsWorkflow(suggestionIds);
    }
      fetchSuggestionsWorkflow(suggestionIds);
  }

  getLeafNodes = (node) => {
    if (!node.hasChildNodes()) {
      // nodeType 3 indicates Text node
      if (node.nodeType === 3 && node.wholeText.trim() !== "") {
        var text = node.wholeText;
        var newNode = document.createElement("span");
        newNode.innerHTML = this.wrapWords(text);
        var parentNode = node.parentNode;
        // Bail out if already suggestion is attached
        if (parentNode.classList.contains("has_comments") || parentNode.classList.contains("has_other_comments") ||parentNode.classList.contains("has_some_comments")) {
          return;
        }
        parentNode.insertBefore(newNode, node);
        parentNode.removeChild(node);
      }
      return;
    } else {
      node.childNodes.forEach(childNode => this.getLeafNodes(childNode));
    }
  }

  wrapWords = (str)  => {
    return str.replace(/(\S+\s*)/g, "<span>$&</span>");
  }

  getSelectedText = (innerDocument) => {
    const t = innerDocument.all
      ? innerDocument.selection.createRange().text
      : innerDocument.getSelection();
    return t;
  }

  handleMouseUp = (innerDocument) => {
    if (!this.state.isEditing === true )  return 
    this.restoreSelectionStyling(innerDocument);
    let selection = this.getSelectedText(innerDocument);
    let range = selection.getRangeAt(0);
    if (selection.anchorNode === selection.focusNode) {
        range.startContainer.parentElement.classList.add("selected");  
    }
    let startNode = range.startContainer;
    let endNode = range.endContainer;

    while (startNode) {
      startNode = this.getNextNode(startNode, false, endNode)
    }

    let selectedText = "";
    if (selection.anchorNode === selection.focusNode) {
      selectedText = selection.anchorNode.textContent;
    } else {
      selectedText = selection.toString();
    }
    let data = {...this.state.data};
    data.selected = selectedText
    this.setState({data})
    this.setState({ suggestionDescription: "" });
   }

  getNextNode = (node, skipChildren, endNode) => {
    if (!this.state.isEditing === true) return
      if (
        node &&
        node.hasChildNodes() &&
        node.childNodes.length === 1 &&
        node.childNodes[0].nodeType === 3
      ) {
        node.classList.add("selected");
      }
      if (endNode === node) {
        return null;
      }
      //if there are child nodes and we didn't come from a child node
      if (node.firstChild && !skipChildren) {
        return node.firstChild;
      }
      if (!node.parentNode) {
        return null;
      }
      return node.nextSibling || this.getNextNode(node.parentNode, true, endNode);
  }

  cancelSuggestion = () => {
    this.setState({ suggestionDescription : "" })
  }
  
  submitSuggestion = () => {
    const { postSuggestionWorkflow, slug , pages , updatePageContent,  updateReviewerSuggestions, userType, userId } = this.props;
    let suggestion = this.state.suggestionDescription;
    let innerDocument = getInnerHTML()[0];
    let contentEl = getInnerHTML()[1];
    let randomClassName = this.generateRandomHex();
    innerDocument.querySelectorAll(".selected").forEach(el => {
      el.classList.remove("selected");
      if (this.state.data.selected !== '' && this.state.suggestionDescription.trim() !== '') {
        el.classList.add("has_comments");
        el.classList.toString();
        el.classList.add(randomClassName);
        el.setAttribute(
          "data-comment-attached",
          selectionStates.selectedAndCommented
        );
      }
    });

    let data = { ...this.state.data };
    data.suggestion = suggestion;
    data.id = randomClassName;
    this.setState({ data }, function() {
    });

    contentEl.getElementsByClassName("content")[0].style.visibility = "hidden"

   // We have added "has_other_comments" class sothat reviewer can't see other reviewer's suggestions but we have to change class back to "has_comments" so the content doesn't get update and suggestions for that reviewer should persist.
    contentEl.querySelectorAll(".has_other_comments").forEach(el => {
      el.classList.remove("has_other_comments");
      el.classList.add("has_comments");
    })
    let that = this ;
    let currentPage = pages.find(function(page) {
      return page.pagePostion === that.state.currentPage  });	
    if(data.selected !== '' && this.state.suggestionDescription.trim() !== '') {
    const postSuggestPayload = {page_number: currentPage.pageId , suggestion: data.suggestion ,selection_text: data.selected , story_id: slug , updated_page_content: contentEl.getElementsByClassName("content")[0].innerHTML, suggestion_id: data.id}
    postSuggestionWorkflow( postSuggestPayload ).then(response => {
      if(response.ok) {
        if (this.props.readSource === gaReadSource.storyDetailsPage && this.isUserNotAuthor()) {
          window.dataLayer.push({
            'category': gaEventLabel.storyModal,
            'event': gaEventActions.registrationComplete,
            'label': gaEventCategories.suggestEdits,
            'item_type': gaEventLabel.language,
            'item_value': this.props.book.language,
            'item_id': null,
            'user_profile': userType,
            'user_id': userId
          })
         }
      }
     })  
    } 
    
   updatePageContent(innerDocument.getElementById('storyReader').parentElement.innerHTML, currentPage.pageId)  
   updateReviewerSuggestions(data.id)
  //  TODO : we tried to capture eventlistener on the updated content here after submitting the suggestions , its hacky way of doing it, we are delaying function call sothat content gets update .

   setTimeout(() => this.init(), 0);	
    this.setState({
      data: {
        selected: '',
        suggestion: '',
        id: ''
      },
      suggestionDescription: ""
    })

  } 

  // Ref. https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
  generateRandomHex = () => {
    return Math.random()
      .toString(36)
      .substring(3);
  }

  restoreSelectionStyling = (innerDocument) => {
    innerDocument.querySelectorAll(".selected").forEach(el => {
      el.classList.remove("selected");
      el.removeAttribute("data-comment-attached");
    });
  }

  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  onSuggestEdits = () => {  
    const { addSlimNotification, t, userType, userId } = this.props;

    if (!this.props.isEmailConfirmed) {
      addSlimNotification({
        id: "OTP.confirm-email-action",
        content: t('OTP.confirm-email-action', { action: t('global.suggest-edits') })
      });
      return;
    }

    let contentEl = getInnerHTML()[1];
    //removing svg node from HTML DOM if editing mode is enabled sothat selection can happen
    this.setState({
      isEditing: !this.state.isEditing
    }, function () {
      if (this.state.isEditing === true) { 
       let svgEl = contentEl.querySelector('svg')
       if(svgEl) {
        contentEl.removeChild(svgEl);
       }
       if (this.props.readSource === gaReadSource.storyDetailsPage && this.isUserNotAuthor()) {
        window.dataLayer.push({
          'category': gaEventLabel.storyModal,
          'event': gaEventActions.clickedSuggestEdits,
          'label': gaEventCategories.suggestEdits,
          'item_type': null,
          'item_id': null,
          'item_value': null, 
          'user_profile': userType,
          'user_id': userId
        })
       }
     // checking for user (not author) that other reviewer's comments are there , then reversing the class "has_other_comments" otherwise "has_comments" on editing mode
        if (this.isUserNotAuthor()) {
          contentEl.querySelectorAll(".has_some_comments").forEach(el => {
            if (this.props.assets.reviewerSuggestions === null) {
              el.classList.remove("has_some_comments");
              el.classList.add("has_other_comments");
            } else if (this.props.assets.reviewerSuggestions.filter(x => el.classList.contains(x)).length === 0) {
              el.classList.remove("has_some_comments");
              el.classList.add("has_other_comments");
            } else {
              el.classList.remove("has_some_comments");
              el.classList.add("has_comments");
            }
          })
        }
        else {
          contentEl.querySelectorAll(".has_some_comments").forEach(el => {
            el.classList.remove("has_some_comments");
            el.classList.add("has_comments");
          })
        }
      } 
     // removing has_comments and applying dummy class if user is not in editing mode  
      else {
        contentEl.querySelectorAll(".has_comments").forEach(el => {
          el.classList.remove("has_comments");
          el.classList.add("has_some_comments");
        })
        var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
        newElement.style.width = "100%";
        newElement.style.height = "100%";
        newElement.style.position = "absolute";
        newElement.style.top = "0";
        newElement.style.left = "0";
        newElement.setAttribute("viewBox", "0 0 100 100");
        newElement.setAttribute("preserveAspectRatio", "none");
        contentEl.appendChild(newElement);
        this.props.resetSuggestions();

      }
    })
  }

  onUserTyping = (e) => {
    if(e.type === "blur"){
      this.setState({ isTyping : false })
    }
    else if(e.type === "focus"){
      this.setState({ isTyping : true })
    }
  }

  onClickScreenSkip = () => {
     this.setState({ isButtonClicked : true })
  }

  onClickScreenClose = () => {
    this.setState({ isButtonClicked : true })
 }

  onClickScreenNext = () => {
    this.setState({ screenImage : this.props.orientation === "landscape" ? (this.state.screenImage ===  horizontalScreenImages.first ? horizontalScreenImages.second : horizontalScreenImages.third) : (this.state.screenImage ===  verticalScreenImages.first ? verticalScreenImages.second : verticalScreenImages.third)})
  }

  onClickScreenNextForAuthor = () => {
    this.setState({ authorScreenImage : this.props.orientation === "landscape" ? authorHorizontalScreenImages.second : authorVerticalScreenImages.second })
  }

  onCloseBook = () => {
    this.props.closeGlobalBookReader();
    this.setState({ isButtonClicked : false })
  }

  onClose = () => {
    const {
      offline,
      pages,
      openNextReadSuggestions,
      closeGlobalBookReader,
      readingProgramBook,
      disableNextRead,
      translatePartner,
      book,
      readSource,
      profileType,
      lp,
      flpBook,
      onWindowClose
    } = this.props;

    if(getOS() !== operatingSystems.iOS){
      if (this.isReaderFullScreen()) {
        this.exitFullScreen();
      }
    }

    const lastStoryPage = pages.find(page => page.isLastStoryPage === true);
    const readMode = lastStoryPage ? true : false;
    if (readMode && !offline) {
      const isBookHalfRead = pages[this.state.currentPage - 1].pagePostion >= Math.ceil(lastStoryPage.pagePostion / 2);
      if (isBookHalfRead && !readingProgramBook && !flpBook && !translatePartner && !disableNextRead && !lp && readSource !== gaReadSource.stem) {
        openNextReadSuggestions();
      }
    }
    
    closeGlobalBookReader();
    if(readSource === sectionClicked.storyfinderRead) {
      if(this.state.currentPage !== lastStoryPage.pagePostion) {
        window.dataLayer.push({
          'event': gaEventActions.bookNotCompleted,
          'label': gaEventLabel.storyfinder,
          'category': profileType === mapUserGatewayProfileType[userProfileType.STUDENT] ? gaEventCategories.homePageStudent: gaEventCategories.homePage,
          'item_type': gaEventLabel.book,
          'item_id': book.id,
          'item_value': book.title, 
          'user_profile': this.props.userType,
          'user_id': this.props.userId
        })
      }
    }
    else {
      if(this.state.currentPage !== lastStoryPage.pagePostion) {
        this.onTriggerEvents({
          gtmCat: gaEventLabel.storyModal,
          gtmEvent: gaEventActions.bookNotCompleted,
          gtmLabel: gaEventLabel.readerClose,
        })
      }
    }

    this.setState({ isButtonClicked : false })
    if(onWindowClose) onWindowClose()
  }

  hasNextPage = () => {
    if (this.state.currentPage > this.props.pages.length-1 || (this.props.pages[this.state.currentPage -1].isLastStoryPage && (this.props.readSource === gaReadSource.readingProgram || (this.props.isOfflineRp && this.props.readSource === gaReadSource.offlineLibrary) || (this.props.flpBook && this.props.readSource === gaReadSource.offlineLibrary) || this.props.readSource === gaReadSource.csf || this.props.readSource === gaReadSource.ece || this.props.readSource === gaReadSource.flpHome || this.props.lp || this.props.readSource === gaReadSource.stem || this.props.offline || this.props.translatePartner || this.props.disableNextRead))){
      return false;
    }
    return true;
  }

  nextPage = () => {
    const {
      offline,
      book,
      showAudioBookReader,
      assets,
      slug,
      addSmileyRatingModal,
      pages,
      openNextReadSuggestions,
      fetchSmileyRatingBook, 
      readingProgramBook,
      disableNextRead,
      translatePartner,
      setStoryStatusFn,
      storyId,
      themeNumber,
      enrollmentId,
      viewport,
      isLoggedIn,
      readSource,
      flpSetStoryStatusFn,
      isSupplementary,
      checkStoryStatus,
      flpBook,
      campaignSetStoryStatus,
      campaignCheckStoryStatus,
      setFlpProgress,
      profileType,
      isOfflineRp,
      lp,
      onScrollPages
     } = this.props;
    // Track GA when user has clicked next Page and next page is going to be last Story Page
    
    if ( pages[this.state.currentPage].isLastStoryPage) {

      showAudioBookReader
      ?
      this.onTriggerEvents({
        gtmCat: gaEventLabel.storyModal,
        gtmEvent: gaEventActions.listenCompleted,
        gtmLabel: book.id,
      })
      :
      this.onTriggerEvents({
        gtmCat: gaEventLabel.storyModal,
        gtmEvent: gaEventActions.readCompleted,
        gtmLabel: book.id,
      })
    }
    if(readSource === sectionClicked.storyfinderRead) {
      window.dataLayer.push({
        'event':  pages[this.state.currentPage-1].isLastStoryPage ? (showAudioBookReader ? gaEventActions.listenCompleted : gaEventActions.readCompleted ): gaEventActions.bookScrolled,
        'label': gaEventLabel.storyfinder,
        'category': profileType === mapUserGatewayProfileType[userProfileType.STUDENT] ? gaEventCategories.homePageStudent: gaEventCategories.homePage,
        'item_type': null,
        'item_id': null,
        'item_value': null, 
        'user_profile': this.props.userType,
        'user_id': this.props.userId
      })
    }
    let languageOption = SUGGEST_EDIT_LANGUAGES.includes(assets.language)
    let shouldShowOnBoardScreen  = ''
      this.isUserNotAuthor()
        ?
        shouldShowOnBoardScreen  = isLoggedIn && viewport.medium && assets.isTranslation && assets.isPublisher === false && languageOption && !this.props.assets.isAudio && !offline && getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() && !assets.suggestionsBlocked
        :
        shouldShowOnBoardScreen = isLoggedIn && viewport.medium && assets.isTranslation && assets.isPublisher === false && languageOption && !this.props.assets.isAudio && !offline && getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() && assets.suggestionsPresent

    if (this.isUserNotAuthor() && this.state.currentPage === 1 && shouldShowOnBoardScreen) {
      this.props.changeUserFeedbackModalStatusWorkflow(userFeedbackPopups.ReviewerSuggestionPopup)
    } else if (this.state.currentPage === 1 && shouldShowOnBoardScreen) {
      this.props.changeUserFeedbackModalStatusWorkflow(userFeedbackPopups.AuthorSuggestionPopup)
    }

    if(pages[this.state.currentPage].isLastStoryPage && readingProgramBook && readSource !== gaReadSource.csf && readSource !== gaReadSource.ece && readSource !== gaReadSource.flpHome && !showAudioBookReader && (readSource === gaReadSource.readingProgram || (readSource === gaReadSource.offlineLibrary && isOfflineRp))){

        setStoryStatusFn(storyId, enrollmentId, themeNumber,'finished');
    }
    if(pages[this.state.currentPage].isLastStoryPage && flpBook && !showAudioBookReader && !isSupplementary){
      const urlParams = new URLSearchParams(window.location.search);
      const lang = urlParams.get('language') || 'en';
      const grade = urlParams.get('grade') || '1';
      flpSetStoryStatusFn(storyId, enrollmentId, 'finished', book.locale || lang )
      .then(()=>{
        if(readSource !== gaReadSource.offlineLibrary) checkStoryStatus(enrollmentId, lang , grade )
        .then(() => setFlpProgress())
      });
    }
    if(pages[this.state.currentPage].isLastStoryPage && this.props.regId && disableNextRead){
      campaignSetStoryStatus(storyId, this.props.regId, 'finished', this.props.campaignType)
      .then( response =>{ 
        if( response.ok) {
          campaignCheckStoryStatus(this.props.regId, this.props.campaignType);
        }
      }) 
    }
    if ( pages[this.state.currentPage - 1].isLastStoryPage && !offline &&  !translatePartner && !disableNextRead && (readSource !== gaReadSource.readingProgram && (!this.props.isOfflineRp) && !this.props.flpBook && readSource !== gaReadSource.csf && readSource !== gaReadSource.ece && readSource !== gaReadSource.flpHome && !lp && readSource !== gaReadSource.stem)) {

      if (assets.isLanguageReviewer && assets.reviewStory) {
        window.location.href = links.storyReview(slug);
      }	
      else if( !assets.hasSmileyRating ) {
        fetchSmileyRatingBook(slug)
        .then( addSmileyRatingModal({showAudioBookReaderOnBack: showAudioBookReader, storyfinder: readSource=== sectionClicked.storyfinderRead}));
      }
      
      else {
        if((readSource !== gaReadSource.readingProgram || (readSource === gaReadSource.offlineLibrary && !this.props.isOfflineRp) || (readSource === gaReadSource.offlineLibrary && !this.props.flpBook)) && !translatePartner && !disableNextRead){
          openNextReadSuggestions();
        }
      }
      this.onCloseBook();
    }
    
    if (this.hasNextPage()) {
      this.setState({
        currentPage: this.state.currentPage + 1,
        suggestionDescription: "",
        data: {
          selected : '',
          suggestion : '',
          id : ''
        }
      }, () => {
        if(this.props.lp || window.location.href.includes("/stem-literacy-programme")) {
          let iframe = Array.from(document.getElementsByClassName("pb-book-reader__frame"))
          if(iframe.length > 0) {
            iframe.forEach(el => {
              let innerDoc = el.contentDocument || el.contentWindow.document;
              let contentEl = innerDoc.getElementById('storyReader');
              let pageNumberEl=contentEl.getElementsByClassName("page_number")[0];
              if(pageNumberEl)
                pageNumberEl.style.visibility="hidden";
            })
          }
          onScrollPages && onScrollPages();
        }
        (this.props.assets.isAudio && this.props.showAudioBookReader && this.initializeSeekCue()) || (this.props.resetSuggestions() && this.init()) ;
      });
    }
  }

  hasPrevPage = () => {
    if (this.state.currentPage - 1 < 1) {
      return false;
    }

    return true;
  }

  prevPage = () => {
    if (this.hasPrevPage()) {
      this.setState({
        currentPage: Math.max(0, this.state.currentPage - 1),
        suggestionDescription: "",
        data: {
          selected : '',
          suggestion : '',
          id : ''
        }
      }, () => {
        if(this.props.lp || window.location.href.includes("/stem-literacy-programme")) {
          let iframe = Array.from(document.getElementsByClassName("pb-book-reader__frame"))
          if(iframe.length > 0) {
            iframe.forEach(el => {
              let innerDoc = el.contentDocument || el.contentWindow.document;
              let contentEl = innerDoc.getElementById('storyReader');
              let pageNumberEl=contentEl.getElementsByClassName("page_number")[0];
              if(pageNumberEl)
                pageNumberEl.style.visibility="hidden";
            })
          }
          this.props.onScrollPages && this.props.onScrollPages();
        }
        (this.props.assets.isAudio && this.props.showAudioBookReader && this.initializeSeekCue()) || (this.props.resetSuggestions() && this.init()) ;
        if(this.props.readSource === sectionClicked.storyfinderRead) {
          window.dataLayer.push({
            'event':  gaEventActions.bookScrolled,
            'label': gaEventLabel.storyfinder,
            'category': this.props.profileType === mapUserGatewayProfileType[userProfileType.STUDENT] ? gaEventCategories.homePageStudent: gaEventCategories.homePage,
            'item_type': null,
            'item_id': null,
            'item_value': null, 
            'user_profile': this.props.userType,
            'user_id': this.props.userId
          })
        }
      });
    }
  }

  replaceImages = (root, pageId) => {
    if (!root) {
      return;
    }

    const imageEl = root.querySelector('.responsive_illustration');

    if (imageEl) {
        let  imageBlobs = this.state.imageBlobs;
        if (imageBlobs[pageId]) {
          imageEl.setAttribute('src', imageBlobs[pageId]);
        }
        else {
          //If somehow the page's image has not been loaded while prefetching, will start the fetch again here
        // for screen-landscape-lock function, vertical mode was opening but after locking it was taking the same image into landscape mode. Resulting in image pixelation. By taking max of width and height it was resolved. 
        const imageSize = getImageSize(Math.max(this.props.windowDimensions.width, this.props.windowDimensions.height));
          fetch(imageEl.dataset[`size${imageSize}Src`])
            .then(response => response.blob())
            .then(imageBlob => {
              const objectURL = URL.createObjectURL(imageBlob);
              imageEl.setAttribute('src', objectURL);
              imageBlobs[pageId] = objectURL;
              this.setState({
                imageBlobs: imageBlobs
              })
            });
        }
    }

    const publisherLogoEl = root.querySelector('.publisher-logo');

    if (publisherLogoEl) {
      fetch(publisherLogoEl.dataset.size1Src)
        .then(response => response.blob())
        .then(imageBlob => {
          const objectURL = URL.createObjectURL(imageBlob);
          publisherLogoEl.setAttribute('src', objectURL);
        });
    }

    const bookLevelsEl = root.querySelector('.book-levels');

    if (bookLevelsEl) {
      fetch(bookLevelsEl.dataset.size1Src)
        .then(response => response.blob())
        .then(imageBlob => {
          const objectURL = URL.createObjectURL(imageBlob);
          bookLevelsEl.setAttribute('src', objectURL);
        });
    }
  }

  getFullScreenPropValue = (fullScreenProps, el) => {
    const elToTest = el || ReactDOM.findDOMNode(this.iframeWrapperEl);

    if (!elToTest) {
      return;
    }

    const availableFullScreenProp = fullScreenProps.find(p => p in elToTest);
    if (!availableFullScreenProp) {
      return;
    }

    return { val: elToTest[availableFullScreenProp], el: elToTest };
  }

  isReaderFullScreen = () => {
    const iframeEl = ReactDOM.findDOMNode(this.iframeWrapperEl);
    const { val } = this.getFullScreenPropValue([
      'fullscreenElement',
      'mozFullScreenElement',
      'msFullscreenElement',
      'webkitFullscreenElement'
    ], document);

    if (val && val === iframeEl) {
      return true;
    }

    return false;
  }

  enterFullScreen = () => {
    if(getOS() !== operatingSystems.iOS){
      this.setState({isFullScreenClicked: true});
      const { val, el } = this.getFullScreenPropValue([
        'requestFullscreen',
        'mozRequestFullScreen',
        'msRequestFullscreen',
        'webkitRequestFullscreen'
      ]);
  
      if (val) {
        val.bind(el)();
      }       

      this.onTriggerEvents({
        gtmEvent: gaEventActions.enterScreen,
        gtmLabel: gaEventLabel.storyModal,
      })
    }

  }

  exitHandler = () => {
    if(getOS() !== operatingSystems.iOS){
      if (!this.isReaderFullScreen() && this.props.lp) {
        this.setState({isFullScreenClicked: false});
      }
    }
  }

  exitFullScreen = () => {
    const { val, el } = this.getFullScreenPropValue([
      'exitFullscreen',
      'mozCancelFullScreen',
      'msExitFullscreen',
      'webkitExitFullscreen'
    ], document);

    if (val) {
      val.bind(el)();
    }
    this.setState({isFullScreenClicked: false});
        
    this.onTriggerEvents({
      gtmEvent: gaEventActions.exitScreen,
      gtmLabel: gaEventLabel.storyModal,
    })
  }

  onFullScreen = () => {
//whenever checking isReaderFullScreen, please check if its not iPhone or iOS with getOS() !== operatingSystems.iOS. AS iOS doesnot support fullScreen API
    if(getOS() !== operatingSystems.iOS){
      if (this.isReaderFullScreen()) {
        this.exitFullScreen();
      } else {
        this.enterFullScreen();
        this.props.onScrollPages && this.props.onScrollPages();
        }
    }
  }

  // this function is called only for audio stories  
  initializeSeekCue = () => {
    if (!this.props.showAudioBookReader)
      return;
    let audioElement = document.querySelector("audio");
    
    if (audioElement) {
      audioElement.pause();
      this.setState({ playing: false });
      if (this.state.currentPage === 1) {
        this.handlePlay();
        return;
      };
    } 
    
    let minCue = getCueInfo()[0];
    let innerDoc = getCueInfo()[2];
    let dataCues = innerDoc.querySelectorAll('[data-cue]');
    this.setState({ seekCueIdx: minCue });
    if(dataCues.length > 0) {
      dataCues[0].classList.add("audio-highlight");
      this.setState({ disableAudioControls: false }, this.handlePlayWithHighlight);
    } else {
      this.setState({ disableAudioControls: true });
    } 
  }

  handlePlay = () => {
    let audioElement = document.querySelector("audio");
    if(audioElement.paused) {
      audioElement.play();
      this.setState({ playing: true });
    } else {
      audioElement.pause();
      this.setState({ playing: false });
    } 
    let bookReaderRef = this;
    audioElement.onended = function() {
      bookReaderRef.setState({ playing: false });
    };
  }

  handlePlayWithHighlight = () => {
    let audioElement = document.querySelector("audio");
    let bookReaderRef = this;
    let textTracks = audioElement.textTracks; // one for each track element
    let textTrack = textTracks[0]; // corresponds to the first track element
    let prevCueIdx = this.state.seekCueIdx - 2; // - 2 as highlight class is added only after cue change event
    
    textTrack.mode = "showing";
    // condition to make sure text track is successfully loaded
    audioElement.currentTime = textTrack.cues[this.state.seekCueIdx - 1] ? textTrack.cues[this.state.seekCueIdx - 1].startTime : 0;

    if(audioElement.paused) {
      audioElement.play();
      this.setState({ playing: true });
    } else {
      audioElement.pause();
      this.setState({ playing: false });
    } 

    textTrack.oncuechange = function() {
      let cueChangeFromPage = bookReaderRef.state.currentPage;
      let cue = this.activeCues[0]; // assuming there is only one active cue
      let [minCue, maxCue, innerDoc] = getCueInfo();
      let highlightedWords = innerDoc.querySelectorAll(".audio-highlight");
    
      for (let i = 0; i < highlightedWords.length; i++) {
        highlightedWords[i].classList.remove("audio-highlight");
      }

      if (cue) {
        bookReaderRef.setState({ seekCueIdx: +cue.id + 1 }); // as cue array starts from 0
        // highlight all words that is getting skipped whose duration is less than ~200ms
        for(let i = prevCueIdx + 1; i <= cue.id; i++) {
          let cueEl =  innerDoc.querySelector(`span[data-cue='${i}']`);
          if (cueEl) {
            cueEl.classList.add("audio-highlight");
            prevCueIdx = i;
          }
        }

        if(bookReaderRef.state.seekCueIdx < minCue || bookReaderRef.state.seekCueIdx > maxCue) {
          let remainingTime = cue.endTime - audioElement.currentTime;

          bookReaderRef.setState({ seekCueIdx: minCue });
          // pause the audio only after playing the current data cue.
          setTimeout(() => { 
            if(bookReaderRef.state.currentPage > 1 && cueChangeFromPage === bookReaderRef.state.currentPage) {
              audioElement.pause();
              bookReaderRef.setState({
                playing: false
              });
            }
          }, (remainingTime) * 1000);
          
        }
      }
    }
  }

  onTriggerEvents = (obj) => {
    const {gtmCat, gtmLabel, gtmEvent, itemType, itemValue, itemId} = obj;

    if (this.props.readSource === gaReadSource.storyDetailsPage || this.props.readSource === gaReadSource.stem) {
      window.dataLayer.push({
        'category': gtmCat ? gtmCat : (this.props.readSource === gaReadSource.storyDetailsPage ? gaEventCategories.storyDetailsPage : `STEM_${gaEventCategories.storyDetailsPage}`),
        ...(gtmEvent && { 'event': gtmEvent }),
        ...(gtmLabel && { 'label': gtmLabel }),
        'item_type': itemType || null,
        'item_value': itemValue || null,
        'item_id': itemId || null,
        'user_profile': this.props.userType,
        'user_id': this.props.userId || '00000'
      });
    }
  }

  getTouches = (evt) => {
    return (
        evt.touches || // browser API
        evt.originalEvent.touches
    ); // jQuery
  }

  handleTouchStart = (evt) => {
    const firstTouch = this.getTouches(evt)[0];
      this.setState({ xDown: firstTouch.clientX });
      this.setState({ yDown: firstTouch.clientY });
  }

  handleTouchMove = (evt) => {
    if (!this.state.xDown || !this.state.yDown) {
        return;
    }
    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;
    var xDiff = this.state.xDown - xUp;
    var yDiff = this.state.yDown - yUp;

    const offlineHorizontalPortraitView = (this.props.offline && this.props.orientation === "landscape" && window.screen.orientation.type === "portrait-primary") ? true : false;

    if (Math.abs(xDiff) > Math.abs(yDiff) && window.visualViewport.scale === 1 && !offlineHorizontalPortraitView) {
      if (xDiff > 0) {
        this.nextPage();
      } else {
        this.prevPage();
      }
    } else if (Math.abs(yDiff) > Math.abs(xDiff) && window.visualViewport.scale === 1 && offlineHorizontalPortraitView) {
      if (yDiff > 0) {
        this.nextPage();
      } else {
        this.prevPage();
      }
    } else {
      if (yDiff > 0) {
        /* down swipe */
      } else {
          /* up swipe */
      }
    }
    /* reset values */
    this.setState({ xDown: null });
    this.setState({ yDown: null });
  }

  render() {
    const {
      t,
      orientation,
      language,
      offline,
      assets,
      showAudioBookReader,
      addSlimNotification,
      onEditBookDetailClicked,
      book,
      isEditingBook,
      userRoles, 
      isLoggedIn,
      viewport,
      suggestions,
      lp,
      small,
      hideClose,
      id,
      showPortraitMsg    
    } = this.props;

    const {
      cssBlob,
      isLoadingCss,
      currentPage 
    } = this.state;

    const baseClassName = 'pb-book-reader';

    const mountTarget = 'story';

    const fontHref = fontUrls[language];
    const fontLink = fontHref ? `<link rel="stylesheet" type="text/css" href=${fontHref}>` : '';
    const cssLink = cssBlob ? `<link rel="stylesheet" type="text/css" href=${cssBlob} />` : '';
    
    // Added cssBlob link to initialContent Ref. https://github.com/ryanseddon/react-frame-component/issues/74

    const initialContent = `
      <!DOCTYPE html>
      <html>
        <head>
          ${cssLink}
          <base target="_parent">
          ${fontLink}          
        </head>
        <body style="overflow: hidden">
          <div id="${mountTarget}"></div>
          <script>
            document.addEventListener('contextmenu', function (e) {
              e.preventDefault();
            }, false); 
          </script>
        </body>
      </html>
    `;

    let storyPages = assets.pages.filter(function(page) { return page.pageType === pageType.storyPage  });
    let enableStoryPage = assets.pages[this.state.currentPage -1 ] && storyPages.some( p => p.pagePostion === assets.pages[this.state.currentPage -1 ].pagePostion)

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--${orientation}`]: orientation,
      [`${baseClassName}--isEditing`]: this.state.isEditing,
      [`${baseClassName}--lp`]: lp && !this.state.isFullScreenClicked,
      [`${baseClassName}--hide-close`]: hideClose,
      [`${baseClassName}--${orientation}-small`]: lp && small && orientation && !this.state.isFullScreenClicked,
    };

    const frameClasses = {
      [`${baseClassName}__frame`]: true,
      [`${baseClassName}__frame--no-pointer-events`]: offline,
    }

    const footerClasses = {
      [`${baseClassName}__footer`]: true,
      [`${baseClassName}__footer--${orientation}`]: orientation && this.state.isFullScreenClicked,
      [`${baseClassName}__footer--mobile-height `]: !viewport.medium
    }

    const nextControlClasses = {
      [`${baseClassName}__control`]: true,
      [`${baseClassName}__control--next`]: true,
      [`${baseClassName}__control--next-s-m`]: !viewport.medium,
      [`${baseClassName}__control--next-withSuggestEdit`]: (this.state.isEditing && this.state.currentPage !== 1 && enableStoryPage && this.isUserNotAuthor()) || (this.state.isEditing && this.state.currentPage !== 1 && enableStoryPage && !this.isUserNotAuthor())
    }

    const prevControlClasses = {
      [`${baseClassName}__control`]: true,
      [`${baseClassName}__control--prev`] : true,
      [`${baseClassName}__control--prev-s-m`]: !viewport.medium,
    }

    const closeControlClasses = {
      [`${baseClassName}__control`]: true,
      [`${baseClassName}__control--close`] : true,
      [`${baseClassName}__control--close-s-m`]: !viewport.medium,
      [`${baseClassName}__control--next-withSuggestEdit`]: (this.state.isEditing  && this.state.currentPage !== 1 && enableStoryPage && this.isUserNotAuthor()) || (this.state.isEditing && this.state.currentPage !== 1 && enableStoryPage && !this.isUserNotAuthor())  
    }

    if (isLoadingCss) {
      return (<div className={classNames(classes)} >
                <div className={`${baseClassName}__wrapper`}>
                  <LoaderBlock />
                </div>
              </div>)
    }
    let lastPage = this.props.pages.find(function(page) {
      return page.isLastStoryPage === true   });

    let languageOption = SUGGEST_EDIT_LANGUAGES.includes(assets.language)
  
    let enableSuggestEdit = ''
      this.isUserNotAuthor()
        ?
        enableSuggestEdit = isLoggedIn && this.state.currentPage !== 1 && enableStoryPage  && viewport.medium && assets.isTranslation && assets.isPublisher === false && !assets.recommended && languageOption && !this.props.assets.isAudio && !offline && getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() && !assets.suggestionsBlocked && !this.props.showAttributionPage
        :
        enableSuggestEdit = isLoggedIn && this.state.currentPage !== 1 &&  enableStoryPage && viewport.medium && assets.isTranslation && assets.isPublisher === false && !assets.recommended && languageOption && !this.props.assets.isAudio && !offline && getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() && assets.suggestionsPresent &&  !this.props.showAttributionPage


    let enableScreen = ''
    this.isUserNotAuthor()
      ?
      enableScreen = isLoggedIn && this.state.currentPage === assets.frontStoryPagePosition && enableStoryPage && viewport.medium && assets.isTranslation && assets.isPublisher === false && !assets.recommended && languageOption && !this.props.assets.isAudio && !offline && !this.props.showAttributionPage && getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() && !assets.suggestionsBlocked && 
      assets.reviewerSuggestionPopupSeenCount < 3 && this.props.isEmailConfirmed
      :
      enableScreen = isLoggedIn && this.state.currentPage === assets.frontStoryPagePosition &&  enableStoryPage && viewport.medium && assets.isTranslation && assets.isPublisher === false && !assets.recommended && languageOption && !this.props.assets.isAudio && !offline && !this.props.showAttributionPage && getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() && assets.suggestionsPresent && assets.authorSuggestionPopupSeenCount < 3 && this.props.isEmailConfirmed

      return (
      <div className={`${baseClassName}__modal-wrapper ${window.screen.orientation.type === "portrait-primary"? `${baseClassName}__modal-wrapper--rotated` : ""}`} id={id}> 
        {
          enableScreen && this.state.isButtonClicked === false
            ?
            this.isUserNotAuthor()
              ?
              <div className={`${baseClassName}__screen-wrapper`}>
                <img className={`${baseClassName}__image`} src={this.state.screenImage} alt="screen" />
                <div className={`${baseClassName}__button-wrapper`}>
                  {
                    this.state.screenImage === (orientation === "landscape" ? horizontalScreenImages.third : verticalScreenImages.third)
                      ?
                      <Button parentClassName={`${baseClassName}__button-wrapper-button`}
                        label={t("global.close")}
                        variant="primary"
                        onClick={this.onClickScreenClose}
                      />
                      :
                      <div>
                        <Button parentClassName={`${baseClassName}__button-wrapper-button`}
                          label={t("global.next")}
                          variant="primary"
                          onClick={this.onClickScreenNext}
                        />
                        <Link parentClassName={`${baseClassName}__button-wrapper-link`} onClick={this.onClickScreenSkip} noTextDecoration>{t("global.skip")}</Link>
                      </div>
                  }
                </div>
              </div>
              :
              <div className={`${baseClassName}__screen-wrapper`}>
                <img className={`${baseClassName}__image`} src={this.state.authorScreenImage} alt="screen" />
                <div className={orientation === "landscape" ?`${baseClassName}__button-wrapper` : `${baseClassName}__portrait-button-wrapper`}>
                  {
                    this.state.authorScreenImage === (orientation === "landscape" ? authorHorizontalScreenImages.second : authorVerticalScreenImages.second)
                      ?
                      <Button parentClassName={`${baseClassName}__button-wrapper-button`}
                        label={t("global.close")}
                        variant="primary"
                        onClick={this.onClickScreenClose}
                      />
                      :
                      <div>
                        <Button parentClassName={`${baseClassName}__button-wrapper-button`}
                          label={t("global.next")}
                          variant="primary"
                          onClick={this.onClickScreenNextForAuthor}
                        />
                        <Link parentClassName={`${baseClassName}__button-wrapper-link`} onClick={this.onClickScreenSkip} noTextDecoration>{t("global.skip")}</Link>
                      </div>
                  }
                </div>
              </div>
            :
            null
        }      
        <div
          className={classNames(classes)}
          onTouchStart={(e) => {this.handleTouchStart(e)}}
          onTouchMove={(e) => {this.handleTouchMove(e)}}
          ref={ref => this.iframeWrapperEl = ref}>       
          <div 
            className={`${baseClassName}__wrapper`}>
            <div className={classNames(closeControlClasses)}>
                <ModalControlButton icon="close" label={t("global.close")} onClick={this.onClose} outsideWrapper={viewport.medium} closeOutsideWrapper={viewport.medium}/>
            </div>
            {
              this.hasPrevPage()
              ?
              <div className={classNames(prevControlClasses)}>
                <ModalControlButton icon="chevron-left" label={t("global.previous")} disabled={ enableScreen && !this.state.isButtonClicked} onClick={this.prevPage} section="book-reader" outsideWrapper={viewport.medium}/>
              </div>
              :
              null
            } 
            {
              this.hasNextPage()
              ?
              <div className={classNames(nextControlClasses)}>
                <ModalControlButton icon="chevron-right" label={t("global.next")} disabled ={ enableScreen  && !this.state.isButtonClicked } onClick={this.nextPage} section="book-reader" outsideWrapper={viewport.medium}/>
              </div>
              :
              null
            }                              
            <Frame
              className={classNames(frameClasses)}
              initialContent={initialContent}
              mountTarget={`#${mountTarget}`}
              onTouchStart={(e) => {this.handleTouchStart(e)}}
              onTouchMove={(e) => {this.handleTouchMove(e)}}
            >
              <div
                onTouchStart={(e) => {this.handleTouchStart(e)}}
                onTouchMove={(e) => {this.handleTouchMove(e)}}
                dangerouslySetInnerHTML={{ __html: this.props.pages[currentPage - 1] && sanitizeHref(this.props.pages[currentPage - 1].html) }}
                ref={ref => this.replaceImages(ref, this.props.pages[currentPage - 1] && this.props.pages[currentPage - 1].pageId)}
              />
            </Frame>
          </div>
          <div className={classNames(footerClasses)}>
            <div className={`${baseClassName}__page-audio-controls-wrapper`}>
              <div className={viewport.medium ?`${baseClassName}__page-ref`:`${baseClassName}__page-ref--mobile`} >
                {this.state.currentPage} / {this.props.showAttributionPage ? this.props.pages.length : lastPage.pagePostion}
              </div>
              {
                assets.isAudio
                &&
                showAudioBookReader
                &&
                <AudioPlayer
                  playing={this.state.playing}
                  orientation={orientation}
                  handlePlay={this.state.currentPage === 1 ? this.handlePlay : this.handlePlayWithHighlight}
                  audioPath={this.state.currentPage === 1 ? this.state.coverAudioBlob : this.state.audioBlob}
                  vttPath={this.state.currentPage === 1 ? null : assets.vttFilePath}
                  disable={this.state.disableAudioControls}
                  displayTime={userRoles && userRoles.includes(availableRoles.CONTENT_MANAGER) && viewport.medium}
                />
              }
            </div> 
            <div className={`${baseClassName}__link`} >
              
              {
                getOS() !== operatingSystems.iOS && !this.isReaderFullScreen()
                  ?
                  enableSuggestEdit
                    ?
                    <div className={`${baseClassName}__link-item`}>
                      {
                        this.state.isEditing
                          ?
                          <Button parentClassName={`${baseClassName}__link-item-button`}
                            label={this.isUserNotAuthor() ? t("global.edit-done") : t("global.view-done")} onClick={this.onSuggestEdits}
                          />
                          :
                          <Link fullWidth onClick={this.onSuggestEdits}>
                            <SvgIcon name="suggest-edit" title={this.isUserNotAuthor() ? t("global.suggest-edit") : t("global.suggest-view")} size="m" />
                          </Link>
                      }
                    </div>
                    :
                    null
                  :
                  null
              }
              {
                this.state.isEditing  || !this.props.viewport.large
                  ?
                  null
                  :
                  <div className={`${baseClassName}__link-item`}>
                    <Link fullWidth onClick={this.onFullScreen} >
                      <SvgIcon name={getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() ? "fullscreen" : "fullscreen-exit"} title={ getOS() !== operatingSystems.iOS && !this.isReaderFullScreen() ? 
                        t("global.fullscreen") : t("global.exitfullscreen")} size="m" />
                    </Link>
                  </div>
              }
            </div>
          </div>            
        </div>  
        {
          this.state.isEditing && this.state.currentPage !== 1 && enableStoryPage
          && this.isUserNotAuthor()
            ?
            <div className={`${baseClassName}__sidebar`} style={{height: document.getElementsByClassName("pb-book-reader__wrapper")[0].offsetHeight + document.getElementsByClassName(`pb-book-reader__footer`)[0].offsetHeight + 8}}>
              <div className={`${baseClassName}__submit-suggestions-box`}>
                <div className={`${baseClassName}__add-suggestion`}>
                  <TextField
                    label={t('BookReader.add-suggestion-description')}
                    type="multiline"
                    value={this.state.suggestionDescription}
                    onChange={this.onChangeDescriptionClicked}
                    onFocus={this.onUserTyping}
                    onBlur={this.onUserTyping}
                    onKeyPress={this.state.suggestionDescription !== '' ? this.onKeyPress : null}
                    suggestEditInputBox={true}
                  />
                  <div className={`${baseClassName}__add-suggestion-actions`}>
                    <Columnizer columns={['70%', '30%']}>
                      <Link onClick={this.submitSuggestion}>{t("global.submit")}</Link>
                      <Link parentClassName={`${baseClassName}__cancel-link`} onClick={this.cancelSuggestion}>{t("global.cancel")}</Link>
                    </Columnizer>
                  </div>
                </div>
              </div>
              {
                suggestions && suggestions.length > 0
                  ?
                  <div id="sidebar__suggestions">{this.renderSuggestionEls(baseClassName)}</div>
                  :
                  null
              }
            </div>
            :
            null
        }
        {
          this.state.isEditing && this.state.currentPage !== 1 && enableStoryPage && !this.isUserNotAuthor()
            ?
            <div className={`${baseClassName}__sidebar`} style={{height: document.getElementsByClassName("pb-book-reader__wrapper")[0].offsetHeight + document.getElementsByClassName(`pb-book-reader__footer`)[0].offsetHeight + 8}}>
           
               {
                suggestions && suggestions.length > 0 
                ?
                <div id="sidebar__suggestions">{this.renderSuggestionEls(baseClassName)}</div>
                :
                null
                }
            </div>
            :
            null
        }
        {
          this.state.isModalVisible.editBookDetail
          ?
          <div className={`${baseClassName}__edit-modal-wrapper ${this.props.isRtl   ? `${baseClassName}__edit-modal-wrapper--rtl` : ''}` }>
            <EditBookDetailModal
              isVisible={this.state.isModalVisible.editBookDetail}
              onCloseClicked={() => this.onCloseModal('editBookDetail')}
              onEditBookDetailClicked={(name, reason) => onEditBookDetailClicked(book.slug, name, reason)}
              onEdit={this.onEdit}
              text={t('Book.confirm-edit')}
              viewport={viewport}
              isEditingBook={isEditingBook}
              addSlimNotification={addSlimNotification}
              isRtl={this.props.isRtl}
            />
          </div>
          :
          null
        }
        {
          this.state.isModalVisible.confirmEdit
            ?
          <div className={`${baseClassName}__edit-modal-wrapper ${this.props.isRtl   ? `${baseClassName}__edit-modal-wrapper--rtl` : ''}` }>
            <ConfirmModal
              text={t('Book.confirm-edit')}
              onConfirm={() => { this.onCloseModal('confirmEdit'); this.onEdit(); }}
              onClose={() => this.onCloseModal('confirmEdit')}
              viewport={viewport}
              isRtl={this.props.isRtl}
            />
          </div>
            :
            null
        }

        {
          ( showPortraitMsg && !viewport.medium)
          ?
          <Suspense fallback={null}><PortraitViewMessage isRtl={this.props.isRtl}/></Suspense>
          :
          null
        }
      </div>
    );
  }
}

BookReader.propTypes = {
  pages: PropTypes.array.isRequired,
  cssHref: PropTypes.string.isRequired,
  viewport: PropTypes.object.isRequired,
  orientation: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default BookReader;


// WEBPACK FOOTER //
// ./src/components/BookReader/BookReader.jsx